import React, { ReactElement } from 'react';
import { Box } from 'theme-ui';

interface HeaderConfigurationsProps {
  hideTopMenu?: {
    value?: string;
  };
  hideMenu?: {
    value?: string;
  };
  hideLogo?: {
    value?: string;
  };
  hideHeader?: {
    value?: string;
  };
}

const HeaderConfigurations = ({
  hideTopMenu,
  hideMenu,
  hideLogo,
  hideHeader,
}: HeaderConfigurationsProps) => {
  const hideSection = (section: string): ReactElement => {
    const __html =
      section === 'site-header'
        ? `<style>#${section} {display: none !important;}</style>`
        : `<style>#${section} {opacity: 0 !important; pointer-events: none !important;}</style>`;

    return (
      <Box
        dangerouslySetInnerHTML={{
          __html,
        }}
      />
    );
  };

  return (
    <>
      {hideTopMenu?.value &&
        hideTopMenu.value &&
        hideSection('header-top-menu')}
      {hideMenu?.value && hideMenu.value && hideSection('header-menu')}
      {hideHeader?.value && hideHeader.value && hideSection('site-header')}
      {hideLogo?.value &&
        hideLogo.value &&
        hideSection('header-menu-logo .header-logo')}
    </>
  );
};

export default HeaderConfigurations;